import { useState } from "react";
import { Button, Confirm, useRecordContext, useRedirect, useUpdate } from "react-admin";
import { useFormContext } from "react-hook-form";
import { GroupModeEnum } from "shared/enums/globalEnums";
import { OptimizerResourcesEnum } from "shared/enums/resourceMappings";
import { Group, TransformGroupCertificationData } from "./types";
import { transformGroupCertificationData } from "./utils";

const SaveGroupCertificationButton = ({ fetchedGroup }: { fetchedGroup: Group }) => {
  const record = useRecordContext();
  const { getValues, trigger } = useFormContext();
  const [open, setOpen] = useState(false);
  const redirect = useRedirect();
  const [update, { isPending }] = useUpdate();

  const handleClick = async () => {
    const isValid = await trigger();
    if (!isValid) {
      return;
    }

    if (fetchedGroup?.mode === GroupModeEnum.prod) {
      setOpen(true);
    } else {
      handleConfirm();
    }
  };

  const handleDialogClose = () => setOpen(false);

  const handleConfirm = () => {
    update(OptimizerResourcesEnum.OptiGroupsCertifications, {
      id: record && record.id,
      data: transformGroupCertificationData(getValues() as TransformGroupCertificationData),
      previousData: record,
      meta: {
        method: "PATCH",
      },
    });
    setOpen(false);
    redirect("list", OptimizerResourcesEnum.OptiGroupsCertifications);
  };

  return (
    <>
      <Button onClick={handleClick} variant="contained" color="primary" label="Save" />
      <Confirm
        isOpen={open}
        loading={isPending}
        title={`Warning`}
        content="This group is in production mode. Are you sure you want to continue?"
        onConfirm={handleConfirm}
        onClose={handleDialogClose}
      />
    </>
  );
};

export default SaveGroupCertificationButton;
